import { nextStep, callNextStepIfIsValidStep } from '../components/step';


const controlFormSteps = () => {
  const $form = $(window.ClientSideValidations.selectors.forms);

  if ($form.length > 0) {
    $form.enableClientSideValidations();
    const validators = $form[0].ClientSideValidations.settings.validators;

    callNextStepIfIsValidStep($form, validators);

    const buttonNextStep = $('#auth-form__button-1');
    buttonNextStep.click(() => $form.isValid(validators) && nextStep($form));

    const buttonPrevStep = $('#auth-form__button-back-2');
    buttonPrevStep.click(() => {
      $('#generic-step__item-2').removeClass('generic-step__item--active');
      $('#generic-step__item-1').removeClass('generic-step__item--passed');
      $('#generic-step-2').fadeOut(() => $('#generic-step-1').hide().removeClass('hidden').fadeIn());
    });
  }
};


export default controlFormSteps;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/auth/controlFormSteps.js